import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, StafferEarningsResponse } from "@/types";

export const stafferEarningsQueryKey = (userId?: number) =>
  ["staffer-earnings", userId] as const;

export function useGetStafferEarnings({ userId }: { userId?: number } = {}) {
  return useQuery({
    queryKey: stafferEarningsQueryKey(userId),
    queryFn: async () => {
      const path = userId
        ? `staffer-earnings?userId=${userId.toString()}`
        : "staffer-earnings";
      const res = await guacHttpClient.get<
        StafferEarningsResponse,
        HttpResponse<StafferEarningsResponse>
      >(path);
      return res.data;
    },
  });
}
